import { C as m } from "./color-58d56877.js";
import "./@contentful-cca97bae.js";
import "react";
import "./color-string-43e78257.js";
import "./color-name-0faa9c28.js";
import "./simple-swizzle-41fe54f9.js";
import "./color-convert-15c02049.js";
const C = (t) => t.substr(1, t.length), u = (t) => {
  if (!t)
    return !1;
  switch (t[0] === "#" && (t = t.substring(1)), t.length) {
    case 3:
      return /^[0-9A-F]{3}$/i.test(t);
    case 6:
      return /^[0-9A-F]{6}$/i.test(t);
    case 8:
      return /^[0-9A-F]{8}$/i.test(t);
    default:
      return !1;
  }
}, c = (t, {
  numColors: e,
  shiftAmount: a,
  mixColor: n,
  rotate: i,
  saturation: r
}) => {
  const s = u(t) ? t : "transparent";
  return [...new Array(e).keys()].map((o) => u(t) ? m(s).rotate((o + 1) / e * -i).saturate((o + 1) / e * r).mix(m(n), a * (o + 1) / e).string() : "transparent");
}, k = (t) => {
  const e = c(t, {
    numColors: 4,
    shiftAmount: 0.6,
    mixColor: "black",
    rotate: 0,
    saturation: -0.01
  }).reverse().map((r) => r), a = c(t, {
    numColors: 5,
    shiftAmount: 0.8,
    mixColor: "white",
    rotate: 0,
    saturation: 0.2
  }), n = [50, 100, 200, 300, 400, 500, 600, 700, 800, 900], i = [...a.reverse(), t, ...e.reverse()];
  return Object.fromEntries(
    i.map((r, s) => [n[s], r])
  ), Object.fromEntries(i.map((r, s) => [n[s], r]));
};
export {
  k as getChakraColorScale,
  c as getColorsList,
  C as hexToNumber,
  u as isValidHex
};
